import React from "react";
import LabelingImgV1 from "./LabelingImgV1";
import LabelingImgV2 from "./LabelingImgV2";
import PolicyContentV1 from "./PolicyContentV1";
import PolicyContentV2 from "./PolicyContentV2";

export default function Policy({ flag }) {
	return (
		<>
			{flag.key === 1 &&
				<>
					<LabelingImgV1 />
					<PolicyContentV1 />
				</>}
			{flag.key === 2 &&
				<>
					<LabelingImgV2 />
					<PolicyContentV2 />
				</>}
		</>
	);
}
